import { IonAvatar, IonCard, IonCardSubtitle, IonCardTitle, IonIcon, IonItem, IonLabel, IonList, IonPopover } from "@ionic/react";
import "./User.css";
import { useAppSelector } from "../Hooks";
import { selectUser } from "../reducers/UserReducer";
import { useOnlineStatus } from "../utils/useOnlineStatus";
import Logout from "./auth/Logout";
import { isMobile } from "react-device-detect"
import { chevronDown, chevronUp, personCircleOutline } from "ionicons/icons";
import { useState } from "react";
import { default as profile_icon} from "../AE2/static/icons/header/Profile.svg"

const User: React.FC = () => {
  const [isOpened,setIsOpened] = useState(false)
  const user = useAppSelector(selectUser);
  useOnlineStatus();
  const newUI = localStorage.getItem("newUI")?.toLowerCase() === 'true';

  if(newUI){

    return <div>
      {isMobile ? <div ><IonIcon id="user-menu"  style={{fontSize:'25px'}} src={personCircleOutline}></IonIcon></div> :
      <IonItem id="user-menu"  title="Account" className="user-info" lines="none">
        {/* <IonCardTitle style={{margin:'0.5rem'}}>
          {user?.first_name.toUpperCase()} {user?.last_name.toUpperCase()}
        </IonCardTitle> */}
        <IonAvatar className="avatar">
          <img alt='account_silhouette' src = {user?.image_url || profile_icon}/>          
        </IonAvatar>
        <IonLabel  className="name-label">
          <div className="font-helvetica font-16pt font-med text-dark-blue user-first-name">{user?.first_name} <span className="user-last_name" >{user?.last_name}</span></div>
          <div className="font-helvetica font-12pt font-med text-dark-blue user-group">{user?.work_group}</div>
        </IonLabel>
        <div className="chevron-icon" style={{marginLeft:'1rem'}}>
          <IonIcon src={isOpened ? chevronUp :chevronDown}/>
        </div>
      </IonItem>}
      <IonPopover trigger="user-menu" onIonPopoverDidPresent={()=>setIsOpened(true)} onIonPopoverDidDismiss={()=>setIsOpened(false)} mode='md' triggerAction="click" side='bottom' showBackdrop={false}>
        <IonList>
          <IonItem href="/account?tab=general" >Account</IonItem>
          
        </IonList>        
      </IonPopover>
    </div>
  }
  return (
    <IonCard href="/account?tab=general" className="user-info">
      <IonCardTitle className="username" data-testid="menu-username">
        {user?.first_name.toUpperCase()} {user?.last_name.toUpperCase()}
      </IonCardTitle>
      <IonCardSubtitle className="email" data-testid="menu-email">
        {user?.email}
      </IonCardSubtitle>
    </IonCard>
  );
};

export default User;
